import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const SITE = "https://www.ultimateprelaunch.com";

const META = {
  fr: {
    title: "PreNet — Bâtissez une fois, connecté pour la vie",
    desc: "PreNet, la couche communautaire du pré-lancement : inscription gratuite, quatre structures, les personnes d'abord, les tendances ensuite. Prenez votre position.",
    locale: "fr_FR",
  },
  en: {
    title: "PreNet · Pre-launch — Build once, connected for life",
    desc: "PreNet, the community layer of the pre-launch: free registration, four structures, people first, trends second. Take your position before the next opportunity arrives.",
    locale: "en_US",
  },
  de: {
    title: "PreNet · Vorab-Start — Einmal aufbauen, verbunden fürs Leben",
    desc: "PreNet, die Community-Schicht des Vorab-Starts: kostenlose Registrierung, vier Strukturen, Menschen zuerst, Trends danach. Sichere dir jetzt deine Position.",
    locale: "de_DE",
  },
  ru: {
    title: "PreNet · Предзапуск — Построй один раз, подключён навсегда",
    desc: "PreNet — сообщество предзапуска: бесплатная регистрация, четыре структуры, люди на первом месте, тренды следом. Займи свою позицию уже сейчас.",
    locale: "ru_RU",
  },
  es: {
    title: "PreNet — Construye una vez, conectado de por vida",
    desc: "PreNet, la capa comunitaria del pre-lanzamiento: registro gratuito, cuatro estructuras, las personas primero, las tendencias después. Toma tu posición.",
    locale: "es_ES",
  },
  vi: {
    title: "PreNet · Tiền khởi động — Xây một lần, kết nối trọn đời",
    desc: "PreNet, tầng cộng đồng của tiền khởi động: đăng ký miễn phí, bốn cấu trúc, con người trước, xu hướng sau. Giữ vị trí của bạn ngay hôm nay.",
    locale: "vi_VN",
  },
  th: {
    title: "PreNet · พรีเปิดตัว — สร้างครั้งเดียว เชื่อมต่อตลอดชีพ",
    desc: "PreNet ชั้นชุมชนของพรีเปิดตัว: ลงทะเบียนฟรี สี่โครงสร้าง คนมาก่อน เทรนด์ตามหลัง จับตำแหน่งของคุณวันนี้",
    locale: "th_TH",
  },
  hr: {
    title: "PreNet · Predstart — Izgradi jednom, povezan zauvijek",
    desc: "PreNet, zajednički sloj predstarta: besplatna registracija, četiri strukture, ljudi prvo, trendovi poslije. Zauzmite svoju poziciju danas.",
    locale: "hr_HR",
  },
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (url) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = url;
};

// Per-language title/description/canonical/OG for the landing routes;
// pass noindex for non-content pages (admin, member welcome pages).
export const Seo = ({ noindex = false } = {}) => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  useEffect(() => {
    if (noindex) {
      document.title = "PreNet";
      setMeta("name", "robots", "noindex, follow");
      return;
    }
    const pathLang = pathname.match(/^\/(fr|en|de|ru|es|vi|th|hr)\/?$/)?.[1] || null;
    const active = META[pathLang || lang] || META.fr;
    const url = pathLang ? `${SITE}/${pathLang}` : `${SITE}/`;
    document.title = active.title;
    setMeta("name", "description", active.desc);
    setMeta("name", "robots", "index, follow, max-image-preview:large, max-snippet:-1");
    setCanonical(url);
    setMeta("property", "og:title", active.title);
    setMeta("property", "og:description", active.desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:locale", active.locale);
    setMeta("name", "twitter:title", active.title);
    setMeta("name", "twitter:description", active.desc);
  }, [lang, pathname, noindex]);
  return null;
};

export default Seo;
